import type { ISeatStatus } from "../../FacilityManager/Domain/Types/FloorPlan/SeatStatus.type";
import type { FloorAvailability } from "../../../features/FloorManager/typings/floor-inventory.entity";
import { filterListByCategory, tempFilterListByCategory } from "./form.functions";
import { getFloorInventoryIdsForSelection } from "./getFloorInventoryIdsForSelection.function";

/**
 * Builds floor-plan seat status for the workplace step.
 * Non-admins highlight only slot-available desks; inactive inventories stay in disableList.
 * Admins keep disableList for grey colour but still put inactive ids in the selectable pool
 * so Confirm and filter matches work without painting those desks green.
 */
export function buildWorkplaceSeatStatus(
  currentFloor: FloorAvailability,
  filteredSelectables: number[] | undefined,
  canBookInactive: boolean
): ISeatStatus {
  const filterBaseIds = getFloorInventoryIdsForSelection(currentFloor, canBookInactive);

  return {
    availableList: filterListByCategory(filterBaseIds, filteredSelectables),
    tempList: tempFilterListByCategory(filterBaseIds, filteredSelectables),
    occupiedList: currentFloor.occupiedInventoryIds,
    disableList: currentFloor.disabledInventoryIds,
    restrictedList: currentFloor.forbiddenInventoryIds,
    userOccupiedList: currentFloor.userOccupiedInventoryIds ?? [],
    blockedList: currentFloor.blockedInventoryIds ?? []
  };
}
